import React from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import DatosCiudadanoExtranjero from '../../datosCiudadanosExtranjero'
import NuevoEmpadronamientoExtranjero from './CreateUpdateUser'

function EmpadronarActualizar(props) {  
    return (
        <div>
            <NuevoEmpadronamientoExtranjero {...props} 
            // ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                AbrirModalProcesarSolicitudExtranjero={props.AbrirModalProcesarSolicitudExtranjero} ejecutar={props.ejecutar}
            />
            {/* <DatosCiudadanoExtranjero {...props}/> */}
            {/* {props.dataRegistered?.numeroBoleta
                ? ( <DatosCiudadanoExtranjero {...props}/> )
                : ( <NuevoEmpadronamientoExtranjero {...props} /> )
            } */}
        </div>
    );
}

export default connect(mapStateToProps, null)(EmpadronarActualizar);